<selection
  class="mbs-wizard_form mbs-nbf-schedule-step"
  [formGroup]="stepForm">
  <!-- LAYOUT START -->

  <div class="mbs-wizard_form-content">
    <mbs-form-group>
      <div
        class="m-n2 p-1 border rounded"
        [class.border-danger]="invalidScheduleTypeSelection"
        [class.border-transparent]="!invalidScheduleTypeSelection"
        [id]="elementSelectors.id.rootDiv">
        <ng-container *ngTemplateOutlet="defaultMode"></ng-container>
        <ng-container *ngTemplateOutlet="simpleMode"></ng-container>
        <ng-container *ngTemplateOutlet="advancedMode"></ng-container>
        <ng-container *ngTemplateOutlet="additional"></ng-container>
      </div>
    </mbs-form-group>
  </div>

  <!-- LAYOUT END -->

  <ng-template #defaultMode>
    <div [id]="elementSelectors.id.defaultModeBlock">
      @if (hasFFIProblem) {
        <mbs-alert
          [attr.data-e2e]="elementSelectors.id.invalidFFIAlert"
          [icon]="true"
          [type]="mbsPopupType.danger">
          {{ simpleDisabledMessage }}
        </mbs-alert>
      }
      @if (!isFFIEnabled || isRDMode) {
        <mbs-alert
          [attr.data-e2e]="elementSelectors.id.oldAgentForFFIAlert"
          [icon]="true"
          [type]="mbsPopupType.danger">
          {{ 'wizards:ffi_label_min_version_attention' | i18next }}
        </mbs-alert>
      }
      <div class="row">
        <!-- Simple -->
        <div class="col-6">
          <mbs-tile
            [autoDeselect]="false"
            [data]="null"
            [disabled]="isSimpleDisabled || invalidFFIStorageReason.syntheticFull"
            [headerTemplate]="headerTemplateSimple"
            [id]="elementSelectors.id.tileSimple"
            [selectable]="true"
            [selected]="isSimpleMode"
            [showBody]="false"
            (click)="activateTile('ffi')">
            <ng-template #headerTemplateSimple>
              <div class="row w-100 pt-1">
                <ng-container *ngTemplateOutlet="innerHeaderTemplateSimple"></ng-container>
              </div>
              <div class="row w-100 pb-3">
                <div class="col pl-5 pr-0 ml-2 text-sm">
                  <div>{{ 'wizards:schedule.defaultMode.simpleDescription' | i18next }}</div>
                </div>
              </div>
              <ng-template #innerHeaderTooltipSimple>
                <div class="text-black">{{ 'wizards:schedule.defaultMode.simpleTooltip1' | i18next }}</div>
                <div class="text-black">{{ 'wizards:schedule.defaultMode.simpleTooltip2' | i18next }}</div>
              </ng-template>
              <ng-template #innerHeaderTemplateSimple>
                <div class="col-11 pl-3">
                  <div class="ml-1">
                    <span class="text-primary m-2 mr-2 pr-1 fa fa-calendar-o"></span>
                    <strong>{{ 'wizards:schedule.defaultMode.simpleTitle' | i18next }}</strong>
                    <span
                      class="cursor-help fa fa-info-circle text-info ml-2"
                      [ngbTooltip]="innerHeaderTooltipSimple"></span>
                  </div>
                </div>
                <div class="col-1 pl-1">
                  <mbs-radio
                    formControlName="ScheduleType"
                    name="ScheduleType"
                    [disabledSelf]="isSimpleDisabled"
                    [label]=""
                    [value]="'ffi'"></mbs-radio>
                </div>
              </ng-template>
            </ng-template>
          </mbs-tile>
        </div>
        <!-- Advanced -->
        <div class="col-6">
          <mbs-tile
            [autoDeselect]="false"
            [data]="null"
            [headerTemplate]="headerTemplate"
            [id]="elementSelectors.id.tileAdvanced"
            [selectable]="true"
            [selected]="isAdvancedMode"
            [showBody]="false"
            (click)="activateTile('predefined')">
            <ng-template #innerHeaderTooltipAdvanced>
              <div>{{ 'wizards:schedule.defaultMode.advancedTooltip1' | i18next }}</div>
              <div>{{ 'wizards:schedule.defaultMode.advancedTooltip2' | i18next }}</div>
            </ng-template>
            <ng-template #headerTemplate>
              <div class="row w-100 pt-3">
                <div class="col-11 pl-3">
                  <div class="ml-1">
                    <span class="text-primary m-2 mr-2 pr-1 fa fa-calendar"></span>
                    <strong>{{ 'wizards:schedule.defaultMode.advancedTitle' | i18next }}</strong>
                    <span
                      class="cursor-help fa fa-info-circle text-info ml-2"
                      [ngbTooltip]="innerHeaderTooltipAdvanced"></span>
                  </div>
                </div>
                <div class="col-1 pl-1">
                  <mbs-radio
                    formControlName="ScheduleType"
                    name="ScheduleType"
                    [label]=""
                    [value]="'predefined'"></mbs-radio>
                </div>
              </div>
              <div class="row w-100 pb-3">
                <div class="col pl-5 ml-2 text-sm">
                  <div>{{ 'wizards:schedule.defaultMode.advancedDescription' | i18next }}</div>
                </div>
              </div>
            </ng-template>
          </mbs-tile>
        </div>
      </div>

      <mbs-radio
        class="mt-3"
        formControlName="ScheduleTypeNone"
        [id]="elementSelectors.id.noSchedule"
        [label]="'wizards:schedule.defaultMode.noSchedule' | i18next"
        [value]="true"
        (click)="activateTile('noschedule')"></mbs-radio>
    </div>
  </ng-template>

  <ng-template #simpleMode>
    @if (isSimpleMode) {
      <div [id]="elementSelectors.id.simpleModeBlock">
        <mbs-card
          class="mt-5"
          [size]="MbsSize.sm">
          <mbs-card-group>
            <div class="row">
              <div class="col">
                <strong class="d-flex">{{ 'wizards:schedule.simpleMode.backupSchedule' | i18next }}</strong>
                <mbs-button
                  class="_hover-parent"
                  type="link"
                  [customClasses]="'mw-100 text-wrap text-start multiline-button pl-0'"
                  [id]="elementSelectors.id.buttonSimple"
                  (click)="clickDetails('simple')">
                  {{ this.scheduleInfo.simple }}
                  <span class="_hover-target fa fa-pencil ml-1"></span>
                </mbs-button>
              </div>
            </div>
          </mbs-card-group>
          @if (isFfiSyntheticFullEnabled && showSyntheticFull) {
            <mbs-card-group>
              <div
                class="row"
                [id]="elementSelectors.id.syntheticBlock">
                <div class="col">
                  <strong class="d-flex">{{ 'wizards:schedule.scheduleModal.synthetic.title' | i18next }}</strong>
                  <mbs-button
                    class="_hover-parent"
                    type="link"
                    [customClasses]="'mw-100 text-wrap text-start multiline-button pl-0'"
                    [id]="elementSelectors.id.buttonSynthetic"
                    (click)="clickDetails('simple')">
                    @if (syntheticRequired) {
                      <span class="text-danger">{{ 'wizards:schedule.advancedMode.fullNotConfigured' | i18next }}</span>
                    } @else {
                      {{ this.scheduleInfo.synthetic }}
                    }
                    <span class="_hover-target fa fa-pencil ml-1"></span>
                  </mbs-button>
                </div>
              </div>
            </mbs-card-group>
          }
          <div class="row">
            <mbs-nbf-retention-policy-step-control-panel
              [isHybrid]="!!storage.isHybrid"
              [isWindows]="!isUnix"
              [mode]="'alert'"
              [parentForm]="stepForm"
              [placement]="'schedule'"
              (internalClick)="clickRetention($event)"></mbs-nbf-retention-policy-step-control-panel>
          </div>
        </mbs-card>
      </div>
    }
  </ng-template>

  <ng-template #advancedMode>
    @if (isAdvancedMode) {
      <div [id]="elementSelectors.id.advancedModeBlock">
        <mbs-card
          class="mt-5"
          [size]="MbsSize.sm">
          <mbs-card-group>
            <div class="row">
              <div class="col-11">
                <strong class="d-flex">{{ 'wizards:schedule.advancedMode.incrementalBackupSchedule' | i18next }}</strong>
                <mbs-button
                  class="_hover-parent"
                  type="link"
                  [customClasses]="'mw-100 text-wrap text-start multiline-button pl-0'"
                  [disabled]="!stepForm.get('incrementalData').get('enabled').value"
                  [id]="elementSelectors.id.buttonAdvanced"
                  (click)="clickDetails('advanced')">
                  {{ this.scheduleInfo.incremental }}
                  <span class="_hover-target fa fa-pencil ml-1"></span>
                </mbs-button>
              </div>
              <div class="col-1 d-flex align-items-center">
                <mbs-switcher
                  [disabledSelf]="!stepForm.get('fullBackupData').get('enabled').value"
                  [id]="elementSelectors.id.switcherAdvanced"
                  [selected]="stepForm.get('incrementalData').get('enabled').value"
                  (change)="incrementalEnabledChangeHandler()">
                </mbs-switcher>
              </div>
            </div>
          </mbs-card-group>
          <mbs-card-group>
            <div class="row">
              <div class="col-11">
                <strong class="d-flex">{{ 'wizards:schedule.advancedMode.fullBackupSchedule' | i18next }}</strong>
                <mbs-button
                  class="_hover-parent"
                  type="link"
                  [customClasses]="'pl-0'"
                  [disabled]="!stepForm.get('fullBackupData').get('enabled').value"
                  [id]="elementSelectors.id.buttonFull"
                  (click)="clickDetails('full')">
                  {{ this.scheduleInfo.full }}
                  <span class="_hover-target fa fa-pencil ml-1"></span>
                </mbs-button>
              </div>
              @if (canOffFull) {
                <div class="col-1 d-flex align-items-center">
                  <mbs-switcher
                    [id]="elementSelectors.id.switcherAdvancedFull"
                    [selected]="stepForm.get('fullBackupData').get('enabled').value"
                    (change)="fullEnabledChangeHandler()">
                  </mbs-switcher>
                </div>
              }
            </div>
            @if (notConfiguredFull) {
              <div
                class="row mt-1"
                [id]="elementSelectors.id.alertFull">
                <div class="col-12 p-1">
                  <mbs-alert
                    [icon]="true"
                    [type]="mbsPopupType.danger">
                    <div>{{ 'wizards:schedule.advancedMode.fullNotConfiguredInfo' | i18next }}</div>
                  </mbs-alert>
                </div>
              </div>
            }
            <div class="row">
              <mbs-nbf-retention-policy-step-control-panel
                [isHybrid]="!!storage.isHybrid"
                [isWindows]="!isUnix"
                [mode]="'alert'"
                [parentForm]="stepForm"
                [placement]="'schedule'"
                (internalClick)="clickRetention($event)"></mbs-nbf-retention-policy-step-control-panel>
            </div>
          </mbs-card-group>
        </mbs-card>
      </div>
    }
  </ng-template>

  <ng-template #additional>
    @if (isSimpleMode || isAdvancedMode || isManualMode) {
      <div
        class="mt-3"
        [id]="elementSelectors.id.additionalModeBlock">
        <mbs-button
          type="secondary"
          (click)="clickAdditional()">
          <i class="fa fa-cog"></i>
          <span>{{ 'wizards:schedule.additionalSettings' | i18next }}</span>
        </mbs-button>
      </div>
    }
  </ng-template>
</selection>

<ng-template #FFIPayAttentionGFS>
  @if (retention.isGFSMode) {
    <mbs-alert
      [icon]="true"
      [type]="mbsPopupType.warning">
      {{ 'wizards:ffi_warning_title_prefix' | i18next }}
      <strong>{{ 'wizards:ffi_label' | i18next }}</strong>
      {{ 'wizards:ffi_warning_title_postfix' | i18next }}. {{ 'wizards:ffi_warning_title_with_gfs_prefix' | i18next }},
      <strong>{{ 'wizards:ffi_warning_title_with_gfs' | i18next }}</strong>
      {{ 'wizards:ffi_warning_title_with_gfs_postfix' | i18next }}
    </mbs-alert>
  } @else {
    <mbs-alert
      [icon]="true"
      [type]="mbsPopupType.warning">
      {{ 'wizards:ffi_warning_title_prefix' | i18next }}
      <strong>{{ 'wizards:ffi_label' | i18next }}</strong>
      {{ 'wizards:ffi_warning_title_postfix' | i18next }}
    </mbs-alert>
  }
  <strong>{{ 'shared:notifications.attention' | i18next }}!</strong>
  <ul>
    <li>{{ 'wizards:ffi_warning_aspect_1' | i18next }}</li>
    <li>{{ 'wizards:ffi_warning_aspect_2' | i18next }}</li>
  </ul>
  @if (ability.can('read', 'HelpMarketing')) {
    <a
      class="col-3 d-flex align-items-baseline justify-content-end"
      href="/AP/Help/backup/about/backup-format/ffi"
      target="_blank">
      {{ 'wizards:learn_more_link' | i18next }}
      <span class="ml-1 fa fa-external-link"></span>
    </a>
  }
</ng-template>
